import { Button, type ButtonSize } from '@heidi/design-system/button';
import { cn } from '@heidi/utils';

import type { UpgradeCtaButtonProps } from './types';
import { getUpgradeCtaButtonPreset } from './upgrade-cta-button-presets';

const ICON_SIZE_BY_BUTTON_SIZE: Record<ButtonSize, number> = {
  xxs: 12,
  xs: 12,
  sm: 14,
  md: 14,
  lg: 16,
  touch: 16,
};

/** Dumb tier-styled upgrade CTA. Presets map tier → button variant + icon. */
export function UpgradeCtaButton({
  tier,
  label,
  onClick,
  disabled = false,
  size = 'lg',
  className,
  'data-testid': testId = 'upgrade-cta-button',
}: UpgradeCtaButtonProps) {
  const { variant, Icon, buttonClassName } = getUpgradeCtaButtonPreset(tier);
  const iconSize = ICON_SIZE_BY_BUTTON_SIZE[size];

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      className={cn('gap-x-1.5', buttonClassName, className)}
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
    >
      <Icon size={iconSize} className="shrink-0" aria-hidden />
      {label}
    </Button>
  );
}
